import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { accordionTransitionTiming } from "@faire/retailer-visitor-shared/components/Accordion/Accordion";
import { AnimatedChevronContainer } from "@faire/retailer-visitor-shared/components/Accordion/AnimatedChevronContainer";
import { ExpandedContent } from "@faire/retailer-visitor-shared/components/Accordion/ExpandedContent";
import { FullControlAccordion } from "@faire/retailer-visitor-shared/components/Accordion/FullControlAccordion";
import { Chevron } from "@faire/retailer-visitor-shared/icons/Chevron/Chevron";
import { Column, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled from "styled-components";
export var Accordion = function(param) {
    var data = param.data, openIndex = param.openIndex, toggleAccordionItem = param.onItemClick;
    return /*#__PURE__*/ _jsx(Column, {
        flex: 1,
        style: {
            width: "100%"
        },
        children: data.map(function(param, index) {
            var title = param.title, description = param.description;
            return /*#__PURE__*/ _jsxs(FullControlAccordion, {
                isOpen: openIndex === index,
                onClick: function() {
                    return toggleAccordionItem(index);
                },
                children: [
                    index === 0 ? /*#__PURE__*/ _jsx(HorizontalLine, {}) : null,
                    /*#__PURE__*/ _jsxs(AccordionItem, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                justify: "space-between",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        color: Core.text.default,
                                        variant: "subheadingSansRegular",
                                        children: title
                                    }),
                                    /*#__PURE__*/ _jsx(AnimatedChevronContainer, {
                                        children: /*#__PURE__*/ _jsx(Chevron, {
                                            direction: "right",
                                            height: 12,
                                            width: 12
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ExpandedContent, {
                                children: [
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: "2x"
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        color: Core.text.subdued,
                                        variant: "paragraphSansMedium",
                                        children: description
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(HorizontalLine, {})
                ]
            }, title);
        })
    });
};
var AccordionItem = styled.div.withConfig({
    componentId: "sc-b44559b8-0"
})([
    "padding:",
    ";",
    ""
], getSpacing("2x", "4x"), accordionTransitionTiming);
